export default __webpack_public_path__ + "static/media/accountPlanBasicPlan.67b59259.svg";